import { z } from 'zod';

export const IMAGE_KEY_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\.webp$/;

export const imageKeySchema = z.string().regex(IMAGE_KEY_PATTERN);

export const imageParamsSchema = z.object({ imageKey: imageKeySchema });

export const uploadedImageSchema = z.object({
  imageKey: imageKeySchema,
  width: z.int().min(1),
  height: z.int().min(1),
});

export type UploadedImage = z.infer<typeof uploadedImageSchema>;

export function imageUrl(imageKey: string): string {
  return `/api/images/${imageKey}`;
}
